
import { useEffect } from 'react'
import Select from 'react-select'
import { EquipmentTypeDDLAPI} from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const EquipmentTypeDataDDL = (props) => {
    const { EquipmentType, setEquipmentType, UnitType, ScreenName} = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_UserID: UserID,
            token: token,
            M_STP_UnitTypeID: UnitType.ID,
        }
        // if(UnitType.ID){
            dispatch(EquipmentTypeDDLAPI({ data }))
        // }
    }, [UnitType.ID])

    const { EquipmentTypeData } = useSelector(state => state.EquipmentTypeDDL)

    useEffect(() => {
        handleSTPEquipmentTypeDDL()
    }, [EquipmentTypeData])

    const handleSTPEquipmentTypeDDL = () => {
        // console.log(DeptDDLDataa)
        if (EquipmentTypeData && EquipmentTypeData.table && EquipmentTypeData.table.length > 0) {
            let list = EquipmentTypeData.table.map((item, index) => ({
                value: item.m_stP_EquipmentTypeID,
                label: item.equipmentType,
            }))

            // setEmployeeDDL({
            //     DDL: list,
            //     ID: Flag === 'Update' ? rowData.m_EmployeeID : 0,
            //     Label: Flag === 'Update' ? rowData.employeeName : "Select...",
            // })
            setEquipmentType({ ...EquipmentType, DDL: list })
        }
        else {
            setEquipmentType({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }
    }
  
return (
    <div className="form-group">
        <label className="d-block" htmlFor="NameofEmployee"><b>Equipment Type </b></label>
        <Select
            // isClearable
            // isRtl={isRtl}
            // className="ddl_width"
            isSearchable
            isDisabled={UnitType.ID == 0 && ScreenName == 'Machinery Operation'}
            maxMenuHeight={150}
            value={{ value: EquipmentType.ID, label: EquipmentType.Label }}
            onChange={(e) => {
                e ?
                    setEquipmentType({ ...EquipmentType, ID: e.value, Label: e.label })
                    :
                    setEquipmentType({ ...EquipmentType, ID: 0, Label: "Select..." })

            }}
            options={EquipmentType.DDL}
        />
    </div>
)
}